<template>
  <v-autocomplete
    v-model="selectedProdutos"
    label="Produtos"
    item-text="modelo"
    item-value="id"
    :items="arrayProdutos"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.modelo }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedProdutos.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";
import ProdutoForca from "@/services/produtoForca"

export default {
  name: "SelectProdutoForca",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      arrayProdutos: [],
      selectedProdutos: [],
      icon: "",
      rules: rules
    };
  },

  methods: {
    async getVeiculos() {
      try {
        const produtos = await new ProdutoForca().getAll();
        this.arrayProdutos = produtos;
      } catch (error) {
        this.$toast.error(error);
      }
    },

    selectAll(all = true) {
      if (all) {
        this.selectedProdutos = this.arrayProdutos.map(value => value.id);
      } else {
        this.selectedProdutos = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedProdutos);
    }
  },

  mounted() {
    this.getVeiculos();
  }
};
</script>
